import {
    CircularProgress,
    Grid,
    InputAdornment,
    TextField, Button,Box
  } from "@mui/material";
  import { Search, SentimentDissatisfied } from "@mui/icons-material";
  import React, { useEffect, useState } from "react";
  import Header from "./Header";
  import './Landingpage.css';
  import UploadIcon from '@mui/icons-material/Upload';
  import { useSnackbar } from "notistack";
  import axios from "axios";
  import MovieCard from "./MovieCard";
  import InputLabel from '@mui/material/InputLabel';
  import MenuItem from '@mui/material/MenuItem';
  import FormControl from '@mui/material/FormControl';
  import Select from '@mui/material/Select';
  import Genre from './Genre';
  import Age from './Age';
  import { config } from "../App";
import UploadModal from './UploadModal';

  //const endpoint = "https://5754aa14-2a01-4c01-9330-49dc7bb033e0.mock.pstmn.io";
  
  const LandingPage=()=>{

    const { enqueueSnackbar } = useSnackbar();
    const[movies, setMovies] = useState([]);
    const[debounceTimeout, setDebounceTimeout]= useState(500);
    let originalURL = config.endpoint+`/videos`;
    const [sortBy, setSortBy] = useState("releaseDate");
    const[genres, setGenres] = useState(["All"]);
    const[contentRating, setCR] = useState("Anyone");
    const[title,setTitle]=useState("");


    let params = "";

    const updateParams = (title, genres,contentRating) =>{

      if(genres[0]!=="All" && contentRating==="Anyone" && title.length===0){
        let genrestr = genres.join(",");
          params = `?genres=${genrestr}`;
      }

      else if(genres[0]==="All"&&contentRating!=="Anyone" && title.length===0){
        params=`?contentRating=${contentRating}`;
      }

      else if(genres[0]==="All"  && contentRating==="Anyone" && title.length>0){
        params = `?title=${title}`;
      }
      else if(genres[0]!=="All" &&contentRating!=="Anyone" && title.length===0){
        let genrestr = genres.join(",");
        params=`?genres=${genrestr}&contentRating=${contentRating}`;
      }
      else if(genres[0]!=="All" && contentRating!=="Anyone" && title.length>0){
        let genrestr = genres.join(",");
        params=`?title=${title}&genres=${genrestr}&contentRating=${contentRating}`;
      }
      else if(genres[0]==="All"&& contentRating!=="Anyone" && title.length>0){
        
        params=`?title=${title}&contentRating=${contentRating}`;
      }
      else if(genres[0]!=="All" &&contentRating==="Anyone" && title.length>0){
        let genrestr = genres.join(",");
        params=`?title=${title}&genres=${genrestr}`;
      }

    }
  // perform api call on load 
    const performAPICall = async (title, genres, contentRating) => {
      updateParams(title, genres, contentRating);
      let URL = originalURL+`${params}`;
      console.log("URL", URL);
      
          try{
              const res = await axios.get(URL);
              setMovies(res.data.videos);
              console.log(res.data.videos);
              //console.log("products inside api call", products);
              return res.data;
          }
          catch(error){
            enqueueSnackbar(error.response.data.message, { variant: "error" });
            console.log(error);
          }
          
    };
    useEffect(() => {
      
      if(title===""){
        performAPICall("",genres, contentRating);
      }
      else{
        performAPICall(title,genres, contentRating);
      }
      
    },[genres, contentRating]);
  
  //search functionality
    const performSearch = async (text) => {
      
      if (text && text.length > 0) {
        setTitle(text);
        console.log("value", text);
        performAPICall(text,genres, contentRating);
      }
      else{
        performAPICall("",genres, contentRating);
      }
     
    };
  
  
    const debounceSearch = (event, debounceTimeout) => {
      
      if (debounceTimeout !== 0) {
         clearTimeout(debounceTimeout);
       }
   
       let debTimout = setTimeout(() => {
         performSearch(event);//async operation , can have old val
       }, 500);
   
       console.log(debTimout);
       setDebounceTimeout(debTimout);
       // debounce login to stop making api request
   
     };
     
     const Sort = async(sort)=>{
      let sortURL = originalURL+`?sortBy=${sort}`
      try{
        const res = await axios.get(sortURL);
        setMovies(res.data.videos);
        console.log(res.data.videos);
        
        }
        catch(error){
          enqueueSnackbar(error.response.data.message, { variant: "error" });
          console.log(error.response.data);
        }

     }
  
      //sort data
      const handler = async (e) => {
        console.log("event ort", e.target.value);
        let sort = e.target.value;
        setSortBy(sort);
        Sort(e.target.value);
      }
  
  
      return (
          <>
          <Box>
          <Box className="top-pannel">
          <Header>
          <TextField 
          className="search-desktop"
          size="small"
          InputProps={{
            className: 'search',
            style:{color:'white', padding:'0'},
            endAdornment: (
              <InputAdornment position="end" >
                <Search style={{color:"#606060", width:"5rem", backgroundColor:"#444D56" , padding:"0.5rem"}} />
              </InputAdornment>
            ), 
          } }
          placeholder="Search"
          name="search"
          onChange = {(e)=>debounceSearch(e.target.value,debounceTimeout)}
        />
          <UploadModal/>
  
          </Header>

          <TextField 
          className="search-mobile"
          size="small"
          fullWidth
          InputProps={{
            style:{color:'white', padding:'0', backgroundColor: "#121212",border: "1px solid #444D56",marginTop:'0.5'},
            endAdornment: (
              <InputAdornment position="end" >
                <Search style={{color:"#606060", width:"5rem", backgroundColor:"#444D56" , padding:"0.5rem"}} />
              </InputAdornment>
            ), 
          } }
          placeholder="Search"
          name="search"
          onChange = {(e)=>debounceSearch(e.target.value,debounceTimeout)}
        />

          <Grid container justifyContent="center"  marginTop="1rem"  direction ="row" columnSpacing={1}>
  
            <Grid justifyContent="center" direction="column"  >
            <Genre genres={genres} setGenres={setGenres}/>
            <Age contentRating={contentRating} setCR={setCR}/>
            </Grid>

            <Grid  justifyContent="center" item mt={1}>
            <FormControl  size="small" >
           
                <Select sx={{ minWidth: 120 , borderRadius:"14px", fontSize:'0.8rem', font:"Roboto" , backgroundColor:"#ffffff", border:'0', width:"fit-content", '.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={sortBy}
                  defaultValue={sortBy}
                  onChange={handler}>
                  <MenuItem value="viewCount">
                    View Count
                  </MenuItem>
                  <MenuItem value="releaseDate">
                  Release Date
                  </MenuItem>
                </Select>
              </FormControl>
              </Grid>
          </Grid>
          </Box>
          
              <Box className = "card-text">
             <Grid  container spacing={1} >
                  {movies.map((movie) => {
                return (
                  <Grid item xs={12} sm={4} md={3} key={movie._id} sx={{width:'3rem'}}>
                    <MovieCard product={movie}/>
                  </Grid>
                );
              })}
              </Grid>
              </Box>
  
  
              </Box>
          </>
  
  
      )
  }
  
  
  export default LandingPage;